import React from 'react';
import { sitesUrls } from "§/src/utils/sitesUrls";

const SchemaProduct = ({ product, acf }) => {
  const currentLang = process.env.GATSBY_SITE_LANG;
  const siteInfo = sitesUrls(currentLang);

  // Funzione per ottenere l'URL completo dell'immagine
  const getFullImageUrl = (imageUrl) => {
    if (!imageUrl) return "";
    if (imageUrl.startsWith("http")) return imageUrl;
    return `${siteInfo.url}${imageUrl}`;
  };

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "ItemPage",
    "@id": "ItemPage",
    "name": product.title,
    "url": `${siteInfo.url}${product.uri}`,
    "description": acf.subTitle,
    "image": getFullImageUrl(acf.gallery && acf.gallery[0] ? acf.gallery[0]?.gatsbyImage?.images?.fallback?.src : ""),
    "conditionsOfAccess": "Accessible only from logged-in accounts",
    "alternateName": acf.subTitle
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schemaData)}
    </script>
  );
};

export default SchemaProduct;
